import React, { useEffect, useState } from 'react';
import { Alert, Dialog, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { analyzeSelfReflections } from '../../api/selfReflection';
import SelfReflectionResults from './SelfReflectionResults';

export default function SelfReflectionQuickViewDialog({ open, subject, onClose }) {
  const [state, setState] = useState({ loading: false, error: '', result: null });

  useEffect(() => {
    if (!open || !subject?.id) return undefined;
    let cancelled = false;
    setState({ loading: true, error: '', result: null });
    analyzeSelfReflections([subject.id], 'combined')
      .then((response) => {
        if (!cancelled) setState({ loading: false, error: '', result: response.data || null });
      })
      .catch((error) => {
        if (!cancelled) setState({ loading: false, error: error.response?.data?.error || 'Auswertung konnte nicht geladen werden.', result: null });
      });
    return () => { cancelled = true; };
  }, [open, subject?.id]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>{`50:50-Auswertung${subject?.fullName ? ` – ${subject.fullName}` : ''}`}</DialogTitle>
      <DialogContent dividers>
        {state.loading && <LinearProgress />}
        {state.error && <Alert severity="error">{state.error}</Alert>}
        {!state.loading && !state.error && (!state.result || state.result.individuals?.[0]?.analysis?.combined?.overallAverage == null) && <Alert severity="info">Noch keine vollständige 50:50-Auswertung vorhanden.</Alert>}
        {state.result?.individuals?.[0]?.analysis?.combined?.overallAverage != null && (
          <SelfReflectionResults config={state.result.config} analysis={state.result.individuals?.[0]?.analysis} mode="combined" fixedMode />
        )}
      </DialogContent>
    </Dialog>
  );
}